export { TabComponent } from './tab.component';
export { TabGroupComponent } from './tab-group.component';
